import classNames from "classnames";
import Text from "../Text";

interface BoxInterface {
  badge?: string | React.ReactNode;
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  leftBlock?: React.ReactNode;
  rightBlock?: React.ReactNode;
  parentClass?: string;
}

export default function Box({ title, description, leftBlock, rightBlock, parentClass, badge }: BoxInterface) {
  const haveHeader = (!!title || !!description);
  return (
    <div className={classNames("my-12 md:px-4", parentClass)}>
      <div /* className="max-w-7xl mx-auto px-12 sm:px-4" */>
        {/* {!!badge && (typeof badge === "string" ? <div className="text-center"><Text type="highlighter" label={badge?.toUpperCase()} /></div> : badge)} */}
        {/* Header Section */}
        {haveHeader && <header className="text-center">
          {!!title && <Text type={"cardTitle"} cName="text-balance text-4xl md:text-4xl sm:text-3xl font-semibold tracking-tight text-[#0C0C0C]" label={title} />}
          {!!description && <Text type="description" cName="mx-auto max-w-7xl mt-4 sm:mt-3 text-xs text-[#4D4D4D] text-pretty font-medium" label={description} />}
        </header>}
        {/* Main Content Section */}
        <div className={classNames("grid grid-cols-2 md:grid-cols-1 gap-8 md:gap-6 sm:gap-4 items-center",haveHeader ? "mt-12 md:mt-12 sm:mt-8" : "" )}>
          {/* Left Side */}
          {leftBlock}
          {/* Right Side - Benefits */}
          {rightBlock}
        </div>
      </div>
    </div>
  );
}